/**
 * Environment kind type and icon resolver for sidebar environment group headers.
 *
 * Adding a new environment (SSH box, remote Mac, Windows PC) means:
 *   1. Add its kind string here
 *   2. Map it to an icon below
 *   3. Render an EnvironmentGroupHeader with that kind
 */

import { CloudIcon, LaptopIcon, MonitorIcon, ServerIcon } from "lucide-react";
import type { LucideIcon } from "lucide-react";

// ---------------------------------------------------------------------------
// EnvironmentKind
// ---------------------------------------------------------------------------

/**
 * Canonical identifiers for every environment type Forge can connect to.
 *
 *  forge-cloud    — CMMD-managed Sprite runtime
 *  desktop-local  — the machine running this Forge instance
 *  remote-desktop — a linked desktop machine (Mac Pro, Windows PC, etc.)
 *  remote-laptop  — a linked laptop
 *  ssh            — a generic SSH-accessible machine
 */
export type EnvironmentKind =
  | "forge-cloud"
  | "desktop-local"
  | "remote-desktop"
  | "remote-laptop"
  | "ssh";

// ---------------------------------------------------------------------------
// Icon resolver
// ---------------------------------------------------------------------------

const ENVIRONMENT_KIND_ICON: Record<EnvironmentKind, LucideIcon> = {
  "forge-cloud": CloudIcon,
  "desktop-local": MonitorIcon,
  "remote-desktop": MonitorIcon,
  "remote-laptop": LaptopIcon,
  ssh: ServerIcon,
};

export function getEnvironmentKindIcon(kind: EnvironmentKind): LucideIcon {
  return ENVIRONMENT_KIND_ICON[kind];
}
